// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start();
require("turbolinks").start();
require("@rails/activestorage").start();
require("channels");
require("listeners");
require("select2");

import { uppyMultipleFileUpload } from "./uppy_file_upload";
import { setClickListeners, setInputListeners } from "listeners/index";

// Admin booking form functions
function initializeAdminBookingForm() {
  const dancerSelect = document.getElementById('dancer_id');
  if (!dancerSelect) return; // Exit if not on booking form page

  const dancersListUrl = dancerSelect.dataset.ajaxUrl;
  const dancerDetailsBaseUrl = dancerSelect.dataset.detailsUrl;

  // Initialize select2 with AJAX for dancer dropdown
  $('#dancer_id').select2({
    placeholder: dancerSelect.dataset.placeholder,
    allowClear: true,
    ajax: {
      url: dancersListUrl,
      dataType: 'json',
      delay: 250,
      data: function (params) {
        return {
          q: {
            first_name_or_last_name_or_email_cont: params.term // search term for Ransack
          },
          page: params.page
        };
      },
      processResults: function (data, params) {
        params.page = params.page || 1;

        return {
          results: data.results,
          pagination: {
            more: false // Assuming we limit results on server side
          }
        };
      },
      cache: true
    },
    minimumInputLength: 2, // Start searching after 2 characters
    templateResult: function(dancer) {
      if (dancer.loading) return dancer.text;

      var $markup = $('<div class="select2-result-dancer clearfix">' +
        '<div class="select2-result-dancer__title">' + dancer.text + '</div>' +
        (dancer.email ? '<div class="select2-result-dancer__description">' + dancer.email + '</div>' : '') +
        '</div>');

      return $markup;
    },
    templateSelection: function(dancer) {
      return dancer.text || dancer.id;
    },
    // Allow clearing the selection
    allowClear: true,
    language: {
      searching: function () {
        return dancerSelect.dataset.searchingText || 'Etsitään tanssijoita...';
      },
      noResults: function () {
        return dancerSelect.dataset.noResultsText || 'Tanssijoita ei löytynyt';
      },
      loadingMore: function () {
        return dancerSelect.dataset.loadingMoreText || 'Ladataan lisää tuloksia...';
      },
      inputTooShort: function () {
        return dancerSelect.dataset.inputTooShortText || 'Syötä vähintään 2 merkkiä hakeaksesi';
      }
    }
  });

  // If there's already a selected dancer (e.g., after validation error), fetch and set it
  var initialDancerId = $('#dancer_id').attr('value') || $('#dancer_id').val();
  if (initialDancerId) {
    // Fetch dancer details and add option to select2
    $.ajax({
      url: dancerDetailsBaseUrl.replace('DANCER_ID', initialDancerId),
      type: 'GET',
      dataType: 'json',
      success: function(data) {
        // Create option and add to select
        var option = new Option(data.first_name + ' ' + data.last_name, initialDancerId, true, true);
        $('#dancer_id').append(option);

        // Trigger change to populate form fields
        $('#dancer_id').trigger('change');
      },
      error: function() {
        console.error('Failed to load initial dancer details');
      }
    });
  }

  // Auto-fill fields when dancer is selected
  $('#dancer_id').on('change', function() {
    var dancerId = $(this).val();
    if (dancerId) {
      // Show loading state
      var $submitBtn = $('input[type="submit"]');
      var originalText = $submitBtn.val();
      var loadingText = dancerSelect.dataset.loadingText || 'Loading...';
      $submitBtn.val(loadingText).prop('disabled', true);

      // Fetch dancer details via AJAX
      $.ajax({
        url: dancerDetailsBaseUrl.replace('DANCER_ID', dancerId),
        type: 'GET',
        dataType: 'json',
        success: function(data) {
          $('#dance_room_booking_first_name').val(data.first_name);
          $('#dance_room_booking_last_name').val(data.last_name);
          $('#dance_room_booking_email').val(data.email);
          $('#dance_room_booking_phone_number').val(data.phone_number);
        },
        error: function() {
          var errorText = dancerSelect.dataset.errorText || 'Error loading dancer information';
          alert(errorText);
        },
        complete: function() {
          // Restore button state
          $submitBtn.val(originalText).prop('disabled', false);
        }
      });
    } else {
      // Clear fields when no dancer selected
      $('#dance_room_booking_first_name').val('');
      $('#dance_room_booking_last_name').val('');
      $('#dance_room_booking_email').val('');
      $('#dance_room_booking_phone_number').val('');
      $('#dance_room_booking_company_name').val('');
    }
  });
}

document.addEventListener("turbolinks:load", event => {
  $('.select2').remove();
  $('.select-js select').removeClass('select2-hidden-accessible');
  $(".select-js select-tags select").select2({ tags: true });

  // Initialize regular select2 dropdowns (excluding dancer_id which has custom AJAX)
  $(".select-js select").not('#dancer_id').select2({ tags: false });

  setClickListeners();
  setInputListeners();

  // Initialize admin booking form if present
  initializeAdminBookingForm();

  Array.from(document.querySelectorAll('.uppy-upload-file')).forEach((fileInput) => {
    uppyMultipleFileUpload(fileInput)
  })

  Array.from(document.querySelectorAll('.uppy-upload-single-file')).forEach((fileInput) => {
    uppyMultipleFileUpload(fileInput, { maxNumberOfFiles: 1 })
  })
})
// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
